// extracted by mini-css-extract-plugin
export default {"failedOrder":"PlaceOrderDegradedMessage-module__failedOrder___3LqhW","failedCall":"PlaceOrderDegradedMessage-module__failedCall___Z65d7"};